export function FlightOfferSummary({ offer }) {
  if (!offer) return null;
  return (
    <div className="booking-offer-summary booking-offer-summary--flight">
      <div className="booking-offer-summary__header">
        {offer.providerLogo && (
          <img src={offer.providerLogo} alt="" className="booking-offer-summary__logo" />
        )}
        <div>
          <p className="booking-offer-summary__label">Selected flight</p>
          <p className="booking-offer-summary__airline">{offer.providerName}</p>
          <p className="muted">{offer.dateLabel}</p>
        </div>
      </div>

      <div className="booking-offer-summary__route-panel">
        <p className="booking-offer-summary__leg-label">Departing</p>
        <div className="booking-offer-summary__route-row">
          <div className="booking-offer-summary__endpoint">
            <span className="booking-offer-summary__code">{offer.fromCode}</span>
            <span className="booking-offer-summary__time">{offer.fromTime}</span>
          </div>
          <div className="booking-offer-summary__timeline">
            <span>{offer.duration}</span>
            <span className="booking-offer-summary__line" aria-hidden />
            <span className="booking-offer-summary__stops">{offer.stops}</span>
          </div>
          <div className="booking-offer-summary__endpoint booking-offer-summary__endpoint--end">
            <span className="booking-offer-summary__code">{offer.toCode}</span>
            <span className="booking-offer-summary__time">{offer.toTime}</span>
          </div>
        </div>
      </div>

      {offer.isRoundTrip && offer.returnFromCode && (
        <div className="booking-offer-summary__route-panel">
          <p className="booking-offer-summary__leg-label">
            Returning{offer.returnDateLabel ? ` · ${offer.returnDateLabel}` : ''}
          </p>
          <div className="booking-offer-summary__route-row">
            <div className="booking-offer-summary__endpoint">
              <span className="booking-offer-summary__code">{offer.returnFromCode}</span>
              <span className="booking-offer-summary__time">{offer.returnFromTime}</span>
            </div>
            <div className="booking-offer-summary__timeline">
              <span>{offer.returnDuration}</span>
              <span className="booking-offer-summary__line" aria-hidden />
              <span className="booking-offer-summary__stops">{offer.returnStops}</span>
            </div>
            <div className="booking-offer-summary__endpoint booking-offer-summary__endpoint--end">
              <span className="booking-offer-summary__code">{offer.returnToCode}</span>
              <span className="booking-offer-summary__time">{offer.returnToTime}</span>
            </div>
          </div>
        </div>
      )}

      <div className="booking-offer-summary__meta">
        <span className="booking-offer-summary__chip">{offer.class}</span>
        <span className="booking-offer-summary__chip">Economy cabin</span>
      </div>
    </div>
  );
}

export function HotelOfferSummary({ offer }) {
  return (
    <div className="booking-offer-summary booking-offer-summary--hotel">
      <p className="booking-offer-summary__label">Selected hotel</p>
      <p className="booking-offer-summary__airline">{offer.name}</p>
      <div className="booking-offer-summary__detail-grid">
        <div>
          <span className="booking-offer-summary__mini-label">Destination</span>
          <strong>{offer.destination}</strong>
        </div>
        <div>
          <span className="booking-offer-summary__mini-label">Check-in</span>
          <strong>{offer.checkIn}</strong>
        </div>
        <div>
          <span className="booking-offer-summary__mini-label">Check-out</span>
          <strong>{offer.checkOut}</strong>
        </div>
        <div>
          <span className="booking-offer-summary__mini-label">Rating</span>
          <strong>
            {offer.stars}★ · {offer.rating}/5
          </strong>
        </div>
      </div>
      {offer.address && <p className="muted booking-offer-summary__address">{offer.address}</p>}
    </div>
  );
}

export function CarOfferSummary({ offer }) {
  return (
    <div className="booking-offer-summary">
      <p className="booking-offer-summary__label">Selected rental</p>
      <p className="booking-offer-summary__airline">
        {offer.type} — {offer.company}
      </p>
      <div className="booking-offer-summary__detail-grid">
        <div>
          <span className="booking-offer-summary__mini-label">Pick-up</span>
          <strong>{offer.pickup}</strong>
        </div>
        <div>
          <span className="booking-offer-summary__mini-label">Dates</span>
          <strong>
            {offer.pickupDate} – {offer.dropoffDate}
          </strong>
        </div>
        <div>
          <span className="booking-offer-summary__mini-label">Vehicle</span>
          <strong>
            {offer.seats} seats · {offer.transmission}
          </strong>
        </div>
      </div>
    </div>
  );
}

export function PackageOfferSummary({ offer }) {
  return (
    <div className="booking-offer-summary">
      <p className="booking-offer-summary__label">Selected package</p>
      <p className="booking-offer-summary__airline">{offer.title}</p>
      <div className="booking-offer-summary__detail-grid">
        <div>
          <span className="booking-offer-summary__mini-label">Destination</span>
          <strong>{offer.destination}</strong>
        </div>
        <div>
          <span className="booking-offer-summary__mini-label">Duration</span>
          <strong>{offer.nights} nights</strong>
        </div>
      </div>
      <p className="muted">
        <strong>Includes:</strong> {offer.includes}
      </p>
    </div>
  );
}

export function CruiseOfferSummary({ offer }) {
  return (
    <div className="booking-offer-summary">
      <p className="booking-offer-summary__label">Selected cruise</p>
      <p className="booking-offer-summary__airline">{offer.line}</p>
      <div className="booking-offer-summary__detail-grid">
        <div>
          <span className="booking-offer-summary__mini-label">Route</span>
          <strong>
            {offer.port} → {offer.destination}
          </strong>
        </div>
        <div>
          <span className="booking-offer-summary__mini-label">Cabin</span>
          <strong>{offer.cabin}</strong>
        </div>
        <div>
          <span className="booking-offer-summary__mini-label">Sail date</span>
          <strong>{offer.departDate}</strong>
        </div>
        <div>
          <span className="booking-offer-summary__mini-label">Nights</span>
          <strong>{offer.nights}</strong>
        </div>
      </div>
    </div>
  );
}
